// @flow

import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import FlexPayPromo from './FlexPayPromo';
import { connect } from 'react-redux';

// Actions
import { gtmUserEvent } from 'store/reducers/gtm/actions';

const mapDispatchToProps = { gtmUserEvent };

export default compose(
  injectIntl,
  connect(
    null,
    mapDispatchToProps
  )
)(FlexPayPromo);



// WEBPACK FOOTER //
// ./src/components/atoms/FlexPayPromo/FlexPayPromoContainer.js